import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Computing from './Computing'
import AnalysisResult from './AnalysisResult'
import { setNonReferableCases, setReferableCases, setResetCases } from '../../../redux/cases'
import { setEvaluations } from '../../../redux/evaluations'
import { stepDecrement } from '../../../redux/steps'
import { URLS } from '../../../const/nav'
import { Container } from './styles'
import { authFetch } from '../../../services/authFetch'

const FINAL_STUDY_STATES = ['diagnosticado referible', 'diagnosticado no referible']
const DIAGNOSIS_IN_FLIGHT_STORAGE_KEY = '_dx_in_flight'

const syncCaseState = (dispatch, studyStatus, dxResult) => {
  if (dxResult === true || studyStatus === 'diagnosticado referible') {
    dispatch(setReferableCases())
    return
  }

  if (dxResult === false || studyStatus === 'diagnosticado no referible') {
    dispatch(setNonReferableCases())
    return
  }

  dispatch(setResetCases())
}

export function StepFour () {
  const dispatch = useDispatch()
  const { cases: caseStatus, evaluations, user } = useSelector(state => state)
  const studyId = evaluations && evaluations.id
  const studyStatus = evaluations && evaluations.estado
  const dxResult = evaluations && evaluations.resumen_DX_IA
  const referenciaPdf = evaluations && evaluations.referenciaPdf
  const token = user && user.token

  useEffect(() => {
    syncCaseState(dispatch, studyStatus, dxResult)

    if (studyStatus && studyStatus !== 'diagnosticando') {
      sessionStorage.removeItem(DIAGNOSIS_IN_FLIGHT_STORAGE_KEY)
    }
  }, [dispatch, studyStatus, dxResult])

  useEffect(() => {
    // Poll mientras el diagnóstico está en curso, o mientras el estado ya es final
    // pero el PDF todavía no quedó persistido.
    const needsPoll = studyStatus === 'diagnosticando' ||
      (FINAL_STUDY_STATES.includes(studyStatus) && !referenciaPdf)

    if (!studyId || !token || !needsPoll) {
      return
    }

    let cancelled = false
    let pollTimer = null

    const pollStudyStatus = async () => {
      try {
        const response = await authFetch(`${URLS.BACKEND_URL}/estudios/${studyId}`, {
          method: 'GET',
          cache: 'no-store',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`
          }
        })

        if (!response.ok || cancelled) {
          console.warn('[POLL] respuesta no ok o instancia cancelada, ignorando. ok:', response.ok, '| cancelled:', cancelled)
          return
        }

        const latestStudy = await response.json()

        if (cancelled || !latestStudy) {
          return
        }

        // 'incompleto' desde la DB no es accionable: puede ser race condition (PUT aún no llegó)
        // o falla de IA que ya fue señalada por evaluate(). El polling nunca actúa sobre este estado.
        if (latestStudy.estado === 'incompleto') {
          return
        }

        if (
          latestStudy.estado !== studyStatus ||
          latestStudy.resumen_DX_IA !== dxResult ||
          latestStudy.referenciaPdf !== referenciaPdf
        ) {
          dispatch(setEvaluations(latestStudy))
          syncCaseState(dispatch, latestStudy.estado, latestStudy.resumen_DX_IA)
        }

        // Detener el polling sólo cuando el estado es final Y el PDF ya está disponible.
        if (FINAL_STUDY_STATES.includes(latestStudy.estado) && latestStudy.referenciaPdf && pollTimer) {
          clearInterval(pollTimer)
          pollTimer = null
        }
      } catch (error) {
        console.error('[POLL] error consultando estado del diagnóstico:', error)
      }
    }

    pollStudyStatus()
    pollTimer = setInterval(pollStudyStatus, 3000)

    return () => {
      cancelled = true
      if (pollTimer) {
        clearInterval(pollTimer)
      }
    }
  }, [dispatch, studyId, studyStatus, dxResult, referenciaPdf, token])

  if (caseStatus === 'idle') {
    const failed = studyStatus === 'incompleto'
    return (
      <Container>
        <Computing
          failed={failed}
          onRetry={() => dispatch(stepDecrement())}
        />
      </Container>
    )
  }

  return (
    <Container>
      <AnalysisResult status={caseStatus} />
    </Container>
  )
}

export default StepFour
